<br><br>
<div>
  <div>
    <div class="chart">
      <canvas baseChart
        [data]="pieChartDataDash"
        [labels]="pieChartLabelsDash"
        [options]="pieChartOptionsDash"
        [plugins]="pieChartPluginsDash"
        [legend]="pieChartLegendDash"
        (chartClick)="chartClicked($event)">
      </canvas>
      <!-- <canvas baseChart
        [data]="pieChartData"
        [labels]="pieChartLabels"
        [chartType]="pieChartType"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [colors]="pieChartColors"
        [legend]="pieChartLegend"
        (chartClick)="chartClicked($event)">
      </canvas> -->
    </div>
  </div>
</div>
